import { z } from 'zod'

export const onboardingStepEnum = z.enum([
  'profileSetup',
  'joinedClub',
  'createdReflection',
  'exploredArchive',
])

export const updateOnboardingSchema = z.object({
  step: onboardingStepEnum,
  completed: z.boolean(),
})

export const onboardingStepsSchema = z.object({
  profileSetup: z.boolean().default(false),
  joinedClub: z.boolean().default(false),
  createdReflection: z.boolean().default(false),
  exploredArchive: z.boolean().default(false),
})

export type OnboardingStep = z.infer<typeof onboardingStepEnum>
export type UpdateOnboardingInput = z.infer<typeof updateOnboardingSchema>
export type OnboardingSteps = z.infer<typeof onboardingStepsSchema>

// Default onboarding steps for new users
export const defaultOnboardingSteps: OnboardingSteps = {
  profileSetup: false,
  joinedClub: false,
  createdReflection: false,
  exploredArchive: false,
}

// Helper to count completed steps
export function countCompletedSteps(steps: OnboardingSteps): number {
  return Object.values(steps).filter(Boolean).length
}

// Helper to get total steps
export const totalOnboardingSteps = 4
